module.exports = __webpack_public_path__ + "img/whatsnew-gradientmap_en.af8d171.jpg";